// Angular
import { Component, OnInit, Input } from "@angular/core";
// Models
// Services
import { Subject } from "rxjs";

import { ApiService } from "../../services/api";
import * as lodash from "lodash";
import * as moment from "moment";

import { OAuthService } from "../../services/o-auth";
import { AngularFireDatabase } from "angularfire2/database";
import { Http } from "@angular/http";
import { FirebaseApp } from "angularfire2";
import { de } from "ngx-bootstrap";
import { l } from "@angular/core/src/render3";

@Component({
  selector: "app-tour-insights",
  templateUrl: "./tour-insights.component.html",
})
export class TourInsightsComponent implements OnInit {
  public parentSubject: Subject<any> = new Subject();
  @Input("profile")
  public profile: any;
  public insights: Array<any>;
  public imageLoader: boolean = true;
  public insight1: any;
  public activateAttachement: any;
  public deactivateAttachement: any;
  public deactivateAttachementExt: String;
  public activateAttachementExt: String;
  public user: any;
  public modalType: number = 1;
  constructor(
    private apiService: ApiService,
    private firebase: FirebaseApp,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase,
    private http: Http
  ) {
    this.insight1 = {
      name: "",
      count: 0,
      status: 1,
      selectedimg: "",
      unselectedimg: "",
    };
  }
  public insightFollower: Array<any>;

  ngOnInit() {
    this.initData();
    this.user = this.oAuthService.getClub();
  }

  public submit() {
    if (this.modalType == 1)
    {
       var isValid = this.checkForm();
    if (!isValid) return;
    this.imageLoader = true;

    // console.log(this.courseCount)
    this.uploadFile().then((res) => {
      console.log(res);
      this.insight1.selectedimg =
        res[0] == undefined ? this.insight1.selectedimg : res[0];

      this.insight1.unselectedimg =
        res[1] == undefined ? this.insight1.unselectedimg : res[1];
      const key =
        this.insight1.$key == undefined
          ? this.fireDatabase.database.ref(`master/tour-insights`).push().key
          : this.insight1.$key;
      // console.log(key)
      delete this.insight1.$key;
      // console.log(key,this.insight)
      this.fireDatabase.database
        .ref(`master/tour-insights/${key}`)
        .set(this.insight1)
        .then((postResult) => {
          this.initData();
          $("#myCourseModal1").modal("hide");
          this.insight1 = {
            name: "",
            count: 0,
            status: 1,
            selectedimg: "",
            unselectedimg: "",
          };
          this.activateAttachement = undefined;
          this.deactivateAttachement = undefined;

          this.notifyChildren(true);
          this.imageLoader = false;
        })
        .catch((error) => {
        });
    });
    }
    else {
       var isValid = this.checkForm();
    if (!isValid) return;
    this.imageLoader = true;

    // console.log(this.courseCount)
    this.uploadFile().then((res) => {
      console.log(res);
      this.insight1.selectedimg =
        res[0] == undefined ? this.insight1.selectedimg : res[0];

      this.insight1.unselectedimg =
        res[1] == undefined ? this.insight1.unselectedimg : res[1];
      const key = this.selectedInsightKey
        this.insight1.$key == this.selectedInsightKey
          // ? this.fireDatabase.database.ref(`master/tour-insights`).push().key
          // : this.insight1.$key;
      // console.log(key)
      delete this.insight1.$key;
      // console.log(key,this.insight)
      this.fireDatabase.database
        .ref(`master/tour-insights/${key}`)
        .update(this.insight1)
        .then((postResult) => {
          this.initData();
          $("#myCourseModal1").modal("hide");
          this.insight1 = {
            name: "",
            count: 0,
            status: 1,
            selectedimg: "",
            unselectedimg: "",
          };
          this.activateAttachement = undefined;
          this.deactivateAttachement = undefined;

          this.notifyChildren(true);
          this.imageLoader = false;
        })
        .catch((error) => {
        });
    });
    }
  }

  async initData() {
    try {
      let profileInsightsKeys = [];
      let p: any;
      if (this.profile) {
        p = await this.apiService.object(`/users/${this.profile.cid}`);
        if (p && p.insights) {
          profileInsightsKeys = Object.keys(p.insights);
        }
      }

      this.fireDatabase.list("master/tour-insights").subscribe(async (res) => {
        this.insights = [];
        if (res && res.length > 0) {
          for (let i = 0; i < res.length; i++) {
            let element: any = res[i];
            if (this.user.type != 3) {
              if (profileInsightsKeys) {
                let t = profileInsightsKeys.filter((x) => x == element.$key);
                if (t.length > 0) {
                  if (p) {
                    let status = p.insights[element.$key];
                    if (status == true) {
                      element.isActive = true;
                    } else {
                      element.isActive = false;
                    }
                  }
                  let map = {
                    ...element,
                    id: element.$key
                  }
                  this.insights.push(map);
                }
              }
            } else {
              let map = {
                ...element,
                id: element.$key
              }
              this.insights.push(map);
            }
          }
        }
        this.getFollower()
      });
    } catch (error) {
      console.log(error);
    }
    this.imageLoader = false;
  }

  public insightClick(not) {
    if (this.user.type != 3 && this.profile) {
      if (not.isActive) {
        if (confirm("Are you sure, you want to disable the notification?")) {
          this.apiService
            .set(`/users/${this.profile.cid}/insights/${not.$key}`, 2)
            .then(() => {
              // this.getClubInsight();
              this.initData();
            })
            .catch((error) => {
              console.error(error);
            });
        }
      } else {
        if (confirm("Are you sure, you want to enable the notification?")) {
          this.apiService
            .set(`/users/${this.profile.cid}/insights/${not.$key}`, 1)
            .then(() => {
              // this.getClubInsight();
              this.initData();
            })
            .catch((error) => {
              console.error(error);
            });
        }
      }
    }
  }

  increaseNotification() {
    lodash.forEach(this.insights, (item, key) => {
      item.count++;
    });
    // console.log(this.notification)
  }

  public followers = [];
  public followerCount = 0;
  getFollower() {
    if (this.profile) {
      const fireObject = this.fireDatabase
        .object(`/user-followers/${this.profile.cid}`)
        .subscribe((result) => {
          if (result && result.count > 0) {
            this.followerCount = result.count;
            lodash.forEach(result.followers, (item, key) => {
              if (item) {
                const fireObject = this.fireDatabase
                  .object(`/user-push-settings/${key}`)
                  .subscribe((result) => {
                    this.increaseNotification();
                    lodash.forEach(result, (item1, key1) => {
                      if (key1 == this.profile.cid) {
                        if (item1) {
                          lodash.forEach(item1, (item2, key2) => {
                            for (var i = 0; i < this.insights.length; i++) {
                              if (key2 == this.insights[i].id && item2) {
                                this.insights[i].count--;
                              }
                            }
                          });
                        }
                      }
                    });
                  });
              }
            });
          }
          if (result && result.count > 0) {
            this.followers = [];
            lodash.forEach(result.followers, (item, key) => {
              if (item) {
                this.fireDatabase.object(`/users/${key}`).subscribe(
                  (result1) => {
                    if (result1) {
                      this.followers.push(result1);
                    }
                  },
                  (error) => {
                    console.error(error);
                  }
                );
              }
            });
          }
        });
    }
  }

  public changedeactivateAttachement(deactivateAttachement: any): void {
    this.deactivateAttachement = deactivateAttachement;

    if (this.deactivateAttachement) {
      this.deactivateAttachementExt = this.deactivateAttachement.file.name
        .split(".")
        .pop();
    } else {
      this.deactivateAttachementExt = "";
    }
  }
  public changeactivateAttachement(activateAttachement: any): void {
    this.activateAttachement = activateAttachement;

    if (this.activateAttachement) {
      this.activateAttachementExt = this.activateAttachement.file.name
        .split(".")
        .pop();
    } else {
      this.activateAttachementExt = "";
    }
  }
  private uploadFile(): Promise<any> {
    // console.log(this.attachment)
    var acProm = new Promise((resolve, reject) => {
      if (this.activateAttachement) {
        const filename = `${moment().unix()}.${Math.floor(
          Math.random() * 900 + 100
        )}.${this.activateAttachementExt}`;
        this.firebase
          .storage()
          .ref(`/tour-insights/`)
          .child(filename)
          .put(this.activateAttachement.file)
          .then((result) => {
            resolve(result.downloadURL);
          })

          .catch((error) => reject(error));
      } else {
        return resolve();
      }
    });
    var deacProm = new Promise((resolve, reject) => {
      if (this.deactivateAttachement) {
        const filename = `${moment().unix()}.${Math.floor(
          Math.random() * 900 + 100
        )}.${this.deactivateAttachementExt}`;
        this.firebase
          .storage()
          .ref(`/tour-insights/`)
          .child(filename)
          .put(this.deactivateAttachement.file)
          .then((result) => {
            resolve(result.downloadURL);
          })

          .catch((error) => reject(error));
      } else {
        return resolve();
      }
    });

    return Promise.all([acProm, deacProm]);
  }
  notifyChildren(err) {
    this.parentSubject.next(err);
  }

  public activate(item) {
    if (confirm("Are you sure,you want to activate this insight?")) {
      this.apiService
        .set(`/master/tour-insights/${item.$key}/status`, 1)
        .then(() => {
          // this.goToPage(this.currentPage);
          item.status = 1;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  public deactivate(item) {
    if (confirm("Are you sure,you want to deactivate this insight?")) {
      this.apiService
        .set(`/master/tour-insights/${item.$key}/status`, 2)
        .then(() => {
          // this.goToPage(this.currentPage);
          item.status = 2;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
  selectedInsightKey;
  public openModal(item, type) {
    this.modalType = type 
    if (item) {
      this.insight1 = { ...item };
      this.insight1.$key = item.$key;
      this.selectedInsightKey = item.id
    }

    $("#myCourseModal1").modal("show");
  }
  public remove(i) {
    switch (i) {
      case 1:
        this.insight1.selectedimg = "";
        break;

      case 2:
        this.insight1.unselectedimg = "";

        break;
    }
  }
  public checkForm() {
    if (this.insight1.name == "") {
      alert("Please enter insight name");
      return false;
    }
    if (
      this.insight1.selectedimg == "" &&
      (this.activateAttachement == undefined ||
        this.activateAttachement == null)
    ) {
      alert("Please select active image");
      return false;
    }
    if (
      this.insight1.unselectedimg == "" &&
      (this.deactivateAttachement == undefined ||
        this.deactivateAttachement == null)
    ) {
      alert("Please select Deactive image");
      return false;
    }
    return true;
  }

  cloneModel() {
    this.insight1 = {
      name: "",
      count: 0,
      status: 1,
      selectedimg: "",
      unselectedimg: "",
    };
  }

  public getFollowerList(id) {
    // console.log(this.follow)
    this.insightFollower = [];

    var followUid = [];
    lodash.forEach(this.followers, (item, key) => {
      if (item) {
        followUid.push(item.$key);

        //  console.log("item   " + item + "  key  " + key)
        const fireObject = this.fireDatabase
          .object(`/user-push-settings/${item.$key}`)
          .subscribe((result) => {
            // console.log(result)
            if (result) {
              lodash.forEach(result, (item1, key1) => {
                if (key1 == this.profile.cid) {
                  // console.log(item1)
                  if (item1) {
                    lodash.forEach(item1, (item2, key2) => {
                      //  console.log(key2)
                      if (id == key2 && item2) {
                        var i = followUid.indexOf(item.$key);
                        //           console.log(i)
                        if (i != -1) {
                          followUid.splice(i, 1);
                        }
                      } else {
                      }
                    });
                  }
                }
              });
            }
          });
      }
    });
    //  console.log(followUid)
    lodash.forEach(followUid, (item, key) => {
      this.fireDatabase.object(`/users/${item}`).subscribe((user: any) => {
        console.log(user);
        this.insightFollower.push(user);
      });
    });
    $("#myModal").modal("show");
  }

}
